// extracted by mini-css-extract-plugin
export default {"ForgotPasswordHeaderContainer":"ForgotPasswordHeader_ForgotPasswordHeaderContainer__Titto","ForgotPasswordHeader":"ForgotPasswordHeader_ForgotPasswordHeader__Sdqi7"};